import { render, staticRenderFns } from "./MainModule.vue?vue&type=template&id=5dead7b8&"
import script from "./MainModule.vue?vue&type=script&lang=js&"
export * from "./MainModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports